// extracted by mini-css-extract-plugin
module.exports =  {"disclaimerFooter":"disclaimerFooter_Sgkk1DQH","privacyLink":"privacyLink_bvexx40B","privacyLinkText":"privacyLinkText_EeY_6mn_","linkIcon":"linkIcon_lNO3j06j"};